import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Alert, Col, Row } from "components/bootstrap";
import useStreamsByIndexSet from "components/inputs/InputSetupWizard/hooks/useStreamsByIndexSet";
const StyledAlert = styled(Alert)`
  margin-top: 0;
  margin-bottom: 0;
`;
const SelectedIndexSetAlert = ({ selectedIndexSetId = void 0, indexSets }) => {
  const { t } = useTranslation("inputs");
  const { data: streamsByIndexSetIdData } = useStreamsByIndexSet(selectedIndexSetId, !!selectedIndexSetId);
  const isDefaultIndexSet = () => {
    var _a;
    const indexSet = indexSets == null ? void 0 : indexSets.find(({ id }) => id === selectedIndexSetId);
    return (_a = indexSet == null ? void 0 : indexSet.default) != null ? _a : false;
  };
  const isAlreadyUsedByStreams = () => {
    if (!streamsByIndexSetIdData) return false;
    return streamsByIndexSetIdData.total > 0;
  };
  if (!selectedIndexSetId) return null;
  if (isDefaultIndexSet()) {
    return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(StyledAlert, { title: t("setup_wizard.index_set_alert.default_title"), bsStyle: "info" }, t("setup_wizard.index_set_alert.default_selected"), /* @__PURE__ */ React.createElement("br", null), t("setup_wizard.index_set_alert.default_recommendation"))));
  }
  if (isAlreadyUsedByStreams()) {
    return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(Alert, { title: t("setup_wizard.index_set_alert.in_use_title"), bsStyle: "info" }, t("setup_wizard.index_set_alert.in_use"), /* @__PURE__ */ React.createElement("br", null), t("setup_wizard.index_set_alert.field_limit"), /* @__PURE__ */ React.createElement("br", null), t("setup_wizard.index_set_alert.organise_recommendation"))));
  }
  return null;
};
export default SelectedIndexSetAlert;
